var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconTwoHearts = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-two-hearts_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161181",
  fill: "none",
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31347",
  clipPath: "url(#icon-two-hearts_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38758",
  d: "M54.857 32A22.857 22.857 0 1132 9.143 22.857 22.857 0 0154.857 32",
  fill: "#f9a23a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38759",
  d: "M17.186 21.274a8.86 8.86 0 0112.529 0l2.662 2.662 2.662-2.662a8.86 8.86 0 0112.529 12.529l-2.662 2.662-12.529 12.529-12.529-12.529-2.662-2.662a8.862 8.862 0 010-12.529",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38760",
  d: "M23.451 17.94a9.536 9.536 0 016.787 2.811l2.14 2.14 2.14-2.14a9.6 9.6 0 1113.574 13.575L32.901 49.517a.739.739 0 01-1.045 0L16.664 34.325a9.6 9.6 0 016.787-16.385zm8.927 6.735a.739.739 0 01-.523-.216l-2.662-2.662A8.12 8.12 0 0017.709 33.28l14.669 14.669L47.046 33.28a8.12 8.12 0 00-11.484-11.484L32.9 24.458a.739.739 0 01-.523.217z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38761",
  d: "M36.78 12.239a4.251 4.251 0 016.012 0l1.277 1.277 1.277-1.277a4.251 4.251 0 016.01 6.012l-1.277 1.277-6.012 6.012-6.011-6.012-1.277-1.277a4.252 4.252 0 010-6.012",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38762",
  d: "M39.786 10.596a4.635 4.635 0 013.287 1.361l1 1 1-1a4.649 4.649 0 116.574 6.574l-1.285 1.281-6.012 6.012a.4.4 0 01-.562 0l-7.289-7.289a4.647 4.647 0 013.287-7.936zm4.283 3.317a.4.4 0 01-.281-.116l-1.281-1.277a3.854 3.854 0 10-5.45 5.45l1.277 1.277 5.731 5.731 7.008-7.008a3.854 3.854 0 10-5.45-5.45l-1.277 1.277a.4.4 0 01-.277.115z",
  fill: "#29398c"
}))));
export default __webpack_public_path__ + "static/icon-two-hearts.9c0d5027704115f4d759215dd241d9db.svg";
export { SvgIconTwoHearts as ReactComponent };